import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewChild } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { firstValueFrom, map } from 'rxjs';

import { SpotlightKey } from '@reach/interfaces/spotlights/spotlights.enum';

import { ClientScreenDirectives } from '~app-client/core/directives';
import { SessionService } from '~app-client/core/services';
import { OnboardingService } from '~app-client/onboarding/services';
import { OnboardingStatus } from '~app-client/onboarding/types';
import { ReachYoutubePlayerModule } from '~app-client/youtube-player/component';
import { UiNewButtons } from '~app-ui-new/buttons';
import { BaseModalComponent, UiNewModals } from '~app-ui-new/modals';

@Component({
	selector: 'home-getting-started',
	templateUrl: './getting-started.component.html',
	styleUrls: ['./getting-started.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [
		CommonModule,
		TranslocoModule,
		ClientScreenDirectives,
		UiNewButtons,
		UiNewModals,
		ReachYoutubePlayerModule,
	],
	host: {
		class: 'dis-none w-0 h-0',
	},
})
export class GettingStartedComponent {
	private readonly onboardingService = inject(OnboardingService);
	private readonly sessionService = inject(SessionService);

	public readonly username$ = this.sessionService.user$.pipe(
		map((user) => {
			return user?.username ?? '';
		})
	);

	@ViewChild('baseModal')
	private readonly baseModal?: BaseModalComponent;

	private reqId = 0;

	public async load(): Promise<void> {
		const reqId = ++this.reqId;

		const status = await firstValueFrom(
			this.onboardingService.keyStatus$(SpotlightKey.HOME__GET_STARTED)
		);

		if (reqId !== this.reqId) {
			return;
		}

		if (status === OnboardingStatus.AVAILABLE) {
			this.openModal();
		}
	}

	public _openTutorial(): void {
		alert('No tutorial link provided');
	}

	public _onModalClosed(): void {
		this.onboardingService.markAsSeen(SpotlightKey.HOME__GET_STARTED, true);
	}

	private openModal(retryCount = 0): void {
		if (retryCount > 10) {
			return;
		}

		if (!this.baseModal) {
			setTimeout(() => {
				this.openModal(retryCount + 1);
			}, 100);
			return;
		}

		this.baseModal.open();
	}
}
